export default __webpack_public_path__ + "static/media/services_makeup.672daed5.jpg";